export function isServer() {
  return typeof document === 'undefined'
}

export function isClient() {
  return typeof document !== 'undefined'
}
